<template>
    <div>
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <!-- Card stats -->
            <div class="row">
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Total traffic"
                                type="gradient-red"
                                sub-title="350,897"
                                icon="ni ni-active-40"
                                class="mb-4 mb-xl-0">

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 3.48%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Total traffic"
                                type="gradient-orange"
                                sub-title="2,356"
                                icon="ni ni-chart-pie-35"
                                class="mb-4 mb-xl-0">

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 12.18%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Sales"
                                type="gradient-green"
                                sub-title="924"
                                icon="ni ni-money-coins"
                                class="mb-4 mb-xl-0">

                        <template slot="footer">
                            <span class="text-danger mr-2"><i class="fa fa-arrow-down"></i> 5.72%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>

                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Performance"
                                type="gradient-info"
                                sub-title="49,65%"
                                icon="ni ni-chart-bar-32"
                                class="mb-4 mb-xl-0">

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 54.8%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div>
            </div>
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col-lg-3">
                    <h3 class="my-4">Order Information</h3>
                    <div class="card">
                        <table class="table mb-0 table-borderless">
                            <tbody>
                            <tr>
                                <th>Total</th>
                                <td>Ksh. {{Math.round(details.total_price)}}</td>
                            </tr>

                            <tr v-if="details.coupon_id">
                                <th>Coupon</th>
                                <td><span class="text-success">{{details.coupon.code}}</span></td>
                            </tr>

                            <tr v-if="details.coupon_id">
                                <th>Discount</th>
                                <td>Ksh: {{-Math.round(details.discount)}}</td>
                            </tr>

                            <tr>
                                <th>Sub-Total</th>
                                <td>Ksh: {{Math.round(details.sub_total)}}</td>
                            </tr>

                            <tr>
                                <th>Status</th>
                                <td>
                                    <span v-if="details.status == 'pending'"
                                          style="color: blue;">{{details.status}}</span>
                                    <span v-if="details.status == 'cancelled'"
                                          style="color: red;">{{details.status}}</span>
                                    <span v-if="details.status == 'completed'"
                                          style="color: green;">{{details.status}}</span>
                                    <span v-if="details.status == 'in-transit'"
                                          style="color: yellow;">{{details.status}}</span>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="card mt-4">
                        <div class="card-header">
                            <h5>Customer Info</h5>
                        </div>
                        <div class="table-responsive">
                            <table class="table mb-0 table-borderless">
                                <tbody>
                                <tr>
                                    <th>Name</th>
                                    <td>{{details.customer.name}}</td>
                                </tr>
                                <tr>
                                    <th>Email</th>
                                    <td>{{details.customer.email}}</td>
                                </tr>
                                <tr>
                                    <th>Phone</th>
                                    <td>{{details.customer.phone}}</td>
                                </tr>
                                <tr>
                                    <th>County</th>
                                    <td>{{details.customer.county}}</td>
                                </tr>
                                <tr>
                                    <th>Town</th>
                                    <td>{{details.customer.town}}</td>
                                </tr>
                                <tr>
                                    <th>Village</th>
                                    <td>{{details.customer.village}}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <!-- /.col-lg-3 -->

                <div class="col-lg-9">

                    <div class="card mt-4">
                        <div class="card-body">
                            <table class="table mb-0">
                                <tbody>
                                <tr>
                                    <th>Order Number</th>
                                    <td>{{details.orderNo}}</td>
                                </tr>

                                <tr>
                                    <th>Payment Status</th>
                                    <td>
                                        <span v-if="details.paid == 1" class="badge badge-success">paid</span>
                                        <span v-if="details.paid == 0" class="badge badge-warning">not paid</span>
                                    </td>
                                </tr>

                                <tr>
                                    <th>Items in order</th>
                                    <td>{{details.items.length}}</td>
                                </tr>

                                <tr>
                                    <th>Phone</th>
                                    <td>{{details.phone}}</td>
                                </tr>

                                <tr>
                                    <th>Delivery</th>
                                    <td>
                                        <span v-if="details.deliver == 'home'">Deliver at my home</span>
                                        <span v-if="details.deliver == 'office'">Pickup at your office</span>
                                    </td>
                                </tr>

                                <tr v-if="details.deliver == 'home'">
                                    <th>County</th>
                                    <td>{{details.county}}</td>
                                </tr>

                                <tr v-if="details.deliver == 'home'">
                                    <th>Delivery Address</th>
                                    <td>{{details.address}}</td>
                                </tr>

                                <tr v-if="details.deliver == 'home'">
                                    <th>Delivery Location Name</th>
                                    <td>{{details.LocationName}}</td>
                                </tr>

                                <tr>
                                    <th>Date</th>
                                    <td>{{moment(details.created_at).format('MMMM Do YYYY, h:mm:ss a')}}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <!-- /.card -->

                    <!--Item card-->
                    <div class="card card-outline-secondary my-4">
                        <div class="card-header">
                            Items in order
                        </div>
                        <div class="card-body table-responsive">
                            <table class="table table-hover shopping-cart-wrap">
                                <thead class="text-muted">
                                <tr>
                                    <th scope="col">Product</th>
                                    <th scope="col" width="120">Quantity</th>
                                    <th scope="col" width="120">Price (Ksh)</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="item in details.items" :key="item.id">
                                    <td>
                                        <figure class="media">
                                            <div class="img-wrap"><img :src="item.product.files[0].filePath"
                                                                       class="img-thumbnail img-sm"
                                                                       style="width: 90px;">
                                            </div>
                                            <figcaption class="media-body pl-3">
                                                <h6 class="title text-truncate">{{item.product.title}}</h6>
                                                <dl v-if="item.product.quantity" class="param param-inline small">
                                                    <dt>Quantity:</dt>
                                                    <dd>{{item.product.quantity}}</dd>
                                                </dl>
                                            </figcaption>
                                        </figure>
                                    </td>
                                    <td>
                                        {{item.quantity}}
                                    </td>
                                    <td>
                                        <div class="price-wrap">
                                            <var class="price">{{item.quantity * item.product.price}}</var>
                                            <small class="text-muted">({{Math.round(item.product.price)}} each)</small>
                                        </div> <!-- price-wrap .// -->
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <!-- /.card -->

                </div>
                <!-- /.col-lg-9 -->

            </div>
            <div class="row mt-3" v-if="details.deliver == 'home'">
                <h5>Delivery Location in Map</h5>
                <hr>
                <GmapMap
                        :center="{lat:parseFloat(details.latitude), lng:parseFloat(details.longitude)}"
                        :zoom="9"
                        map-type-id="terrain"
                        :options="{
                   zoomControl: true,
                   mapTypeControl: false,
                   scaleControl: false,
                   streetViewControl: false,
                   rotateControl: false,
                   fullscreenControl: true,
                   disableDefaultUi: false
                 }"
                        style="width: 100%; height: 500px"
                >
                    <GmapMarker
                            :position="{lat: parseFloat(details.latitude), lng: parseFloat(details.longitude)}"
                            :clickable="true"
                            :draggable="true"
                            @click="center=m.position"
                    />
                </GmapMap>

            </div>

        </div>
    </div>
</template>
<script>
    let moment = require('moment');
    export default {
        name: 'ShippingOrderInfo',
        components: {},
        data() {
            return {
                moment,
                orderNo: this.$route.params.orderNo,
                details: [],
                delivery:[],
                errors: {},
                error: false,
                form: {
                    status: ''
                },
                formR: {
                    rider: ''
                }
            }
        },
        methods: {

            getDetails() {
                this.axios.get('rider/dashboard/showShippingInfo/' + this.orderNo)
                    .then((response) => {
                        this.details = response.data
                    })
                    .catch(() => {

                    })
            },
        },
        created() {
            this.getDetails();

        }

    };
</script>
<style></style>
